module.exports = __webpack_public_path__ + "img/KinokoTable32.626527ac.jpg";